import { Component, Input, TemplateRef, ContentChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  template: `
    <!-- Desktop header -->
    <div class="hidden md:flex justify-between items-center">
      <div>
        <h1 class="titulo">{{ title }}</h1>
        <p class="normal">{{ subtitle }}</p>
      </div>
      @if (actionTemplate) {
        <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
      }
    </div>
    <!-- Mobile header -->
    <div class="md:hidden flex justify-between items-center">
      <div class="flex flex-col">
        <h1 class="titulo">{{ title }}</h1>
        <div class="flex flex-row gap-2">
          <p class="normal">{{ subtitle }}</p>
          @if (actionTemplate) {
            <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
          }
        </div>
      </div>
    </div>
  `,
})
export class PageHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) subtitle!: string;
  @ContentChild('headerAction') actionTemplate?: TemplateRef<unknown>;
}
